import React, { useEffect } from "react";
import { Container } from "../../../components";
import { Icon, Text, Heading } from "@telia/teddy";
import { useLocation } from "react-router";
import { REFILL_LABELS } from "../../../../../constants";
import { trackFunnelEvent } from "../../../google-analytics";
import ContinueSection from "../../components/molecules/ContinueSection/ContinueSection";
import "./RefillReceipt.less";
import TEXT from "../../text-consts";

export default function RefillReceipt() {
    // Trigger GA funnel
    useEffect(() => {
        trackFunnelEvent({ step: "4", label: REFILL_LABELS[3], name: "Refill - Påfyll kontantkort" });
    }, []);
    const location = useLocation();
    return (
        <div className="prepaid-refill">
            <div className="prepaid-refill-receipt">
                <Icon name="check-circle" />
                <Container className="prepaid-refill-receipt__text">
                    <Heading mb="100" as="h1" variant="title-200">
                        {TEXT.REFILL.RECEIPT.HEADING}
                    </Heading>
                    <Text mb="100">{TEXT.REFILL.RECEIPT.INGRESS}</Text>
                    <Text mb="100">
                        <br />
                        {TEXT.REFILL.RECEIPT.FOOTER_TEXT}
                    </Text>
                </Container>
            </div>{" "}
            <ContinueSection path={location.pathname} />
        </div>
    );
}
